// adapter.js
function CustomFetchAdapter(elements) {
  const { url, type, data, headers } = elements;
  const controller = new AbortController();

  const fetchPromise = fetch(url, {
    method: type,
    body:
      data instanceof FormData || data instanceof URLSearchParams
        ? data
        : data
        ? JSON.stringify(data)
        : undefined,
    headers: {
      ...headers,
      ...(data && !(data instanceof FormData)
        ? { "Content-Type": "application/json" }
        : {}),
    },
    signal: controller.signal,
  });

  return {
    async response() {
      const response = await fetchPromise;
      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        const error = new Error(
          errorData?.message || `HTTP error! status: ${response.status}`
        );
        error.status = response.status;
        error.data = errorData;
        throw error;
      }
      const result = await response.json();
      return { ...result, status: response.status };
    },
    async headers() {
      return (await fetchPromise).headers;
    },
    abort() {
      controller.abort();
    },
  };
}

export default CustomFetchAdapter;
